const ReadMore = (() => {
  let s;
  return {
    settings() {
      return {
        content: document.querySelectorAll(".js-read-more"),
        originalContentArr: [],
        truncatedContentArr: [],
        moreLink: "Show More",
        lessLink: "Show Less",
      };
    },
    init() {
      s = this.settings();
      this.bindEvents();
    },
    bindEvents() {
      ReadMore.truncateText();
    },
    countWords(str) {
      return str.split(/\s+/).length;
    },
    ellipseContent(str, wordsNum) {
      return str.split(/\s+/).slice(0, wordsNum).join(" ") + "...";
    },
    truncateText() {
      for (let i = 0; i < s.content.length; i++) {
        const originalContent = s.content[i].innerHTML,
          numberOfWords = s.content[i].dataset.rmWords,
          truncateContent = ReadMore.ellipseContent(
            originalContent,
            numberOfWords,
          ),
          originalContentWords = ReadMore.countWords(originalContent);
        console.log(originalContentWords, numberOfWords);
        if (
          (s.originalContentArr.push(originalContent),
          s.truncatedContentArr.push(truncateContent),
          numberOfWords < originalContentWords)
        ) {
          s.content[i].innerHTML = s.truncatedContentArr[i];
          let self = i;
          ReadMore.createLink(self);
        }
      }
      ReadMore.handleClick(s.content);
    },
    createLink(index) {
      const linkWrap = document.createElement("span");
      ((linkWrap.className = "read-more__link-wrap link-with-border-bottom"),
        (linkWrap.innerHTML = `<a id="read-more_${index}" class="read-more__link" style="cursor:pointer;">${s.moreLink}</a>`),
        s.content[index].parentNode.insertBefore(
          linkWrap,
          s.content[index].nextSibling,
        ));
    },
    handleClick(el) {
      const readMoreLink = document.querySelectorAll(".read-more__link");
      for (let j = 0, l = readMoreLink.length; j < l; j++)
        readMoreLink[j].addEventListener("click", function () {
          let index = this.getAttribute("id").split("_")[1];
          window?.sendTrackingEvent(`${el[index].dataset?.readMoreEvent || 'Read More Link Clicked'}`);
          (el[index].classList.toggle("is-expanded"),
            this.dataset.clicked !== "true"
              ? ((el[index].innerHTML = s.originalContentArr[index]),
                (this.innerHTML = s.lessLink),
                (this.dataset.clicked = !0))
              : ((el[index].innerHTML = s.truncatedContentArr[index]),
                (this.innerHTML = s.moreLink),
                (this.dataset.clicked = !1)));
        });
    },
    openAll() {
      const instances = document.querySelectorAll(".read-more__link");
      for (let i = 0; i < instances.length; i++)
        ((content[i].innerHTML = s.truncatedContentArr[i]),
          (instances[i].innerHTML = s.moreLink));
    },
  };
})();
ReadMore.init();
